import { extend } from 'vee-validate';
import { required, email, excluded } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: '{_field_} ist ein Pflichtfeld'
});

extend('email', {
    ...email,
    message: 'Dies ist keine gültige E-Mail Adresse'
});

extend('new-email', {
    ...excluded,
    message: 'Die Neue E-Mail Adresse darf nicht der aktuellen entsprechen'
});

extend('confirm', {
    params: ['target'],
    validate: (value, { target }) => value === target,
    message: '{_field_} und {target} stimmen nicht überein'
});
